export default __webpack_public_path__ + "static/media/facility_04_3.7b5464d2.png";